<template>
  <v-container fluid ma-0 pa-0 fill-height>
    <div id="map"></div>

      </v-container>
</template>
<script>
import firebase from '@firebase/app';
import   '@firebase/firestore';
import Vue from 'vue'
import BtnComponent from './BtnComponent'
import {Loader } from 'google-maps';
export default {
  data: () => ({
    map: null,
    google: null,
    BtnComponent: Vue.extend(BtnComponent),
    anonymous_cities: {'paris-montmartre': {location: {lat:48.8925 , lng: 2.3444 }},'charleville-mezieres': {location: {lat:49.7667 , lng: 4.7167 }},'dreux': {location: {lat:48.7333 , lng: 1.3667 }}, 'meaux': {location: {lat:48.9562018 , lng: 2.8884657 }}, 'reims': {location: {lat: 49.25, lng:4.0333 }} },
    cities: []
  }),
  mounted(){
    const loader = new Loader('AIzaSyDreGT2CpjlKcExFi_7FXkqzP6E0pHU34w');
    const self = this;
    loader.load().then(function (google) {
      self.google = google;

      self.map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 48.866667, lng:  2.33333},
        zoom: 8,
        panControl: false,
        addressControl: false,
        rotateControl: false,
        disableDefaultUI: true
      });
      let db  = firebase.firestore();
      var bounds = new google.maps.LatLngBounds();
      db.collection('maps').where('enabled', '==', true).get().then((d) => {
        d.docs.forEach((m) => {
          let data = m.data();
          data.id = m.id;
          let marker = null;
          if (data.course) {
            marker = new self.google.maps.Marker({
              position: {lat: data.course.start.location.lat, lng: data.course.start.location.lng},
              map: self.map,
              title: data.title,
            });

            bounds.extend({lat: data.course.start.location.lat, lng: data.course.start.location.lng});


          } else {
            let f_city = self.anonymous_cities[data.id];
            if (f_city) {
              marker = new self.google.maps.Marker({
                position: {lat: f_city.location.lat, lng: f_city.location.lng},
                map: self.map,
                title: data.title,
              });
              bounds.extend({lat: f_city.location.lat, lng: f_city.location.lng});

            }
          }

          var infowindow = new self.google.maps.InfoWindow({
              content: '<h2>'+data.title+'</h2><br/><p id="btnArea"></p>'
            });
         marker.addListener('click', function() {
           infowindow.open(self.map, marker);
           setTimeout(() => {new self.BtnComponent(  {router: self.$router, propsData: { title: data.id,label: self.$t('play') }}).$mount('#btnArea') }, 100);
         });




        })
        self.map.fitBounds(bounds);

      });



    });
  }

}
</script>
<style>
#map {
  height: 100%;
  width: 100%;
}
</style>
